<template>
    <div>
        <tag-selector
            v-if="canManage"
            :current-tags="parent.tags"
            :resource-title="title"
            :working="performingUpdateRequest"
            @close="stopAddingTag"
            @update="handleUpdate"
        />
    </div>
</template>

<script>
import SvgIcon from './ui/SvgIcon.vue';
import TagSelector from './ui/TagSelector.vue';
import {normalizeJson} from '../../shared/helpers';
import _xorBy from 'lodash/xorBy';
import Taggable from "../models/Taggable";
import {useRepo} from "pinia-orm";

export default {
    components: {
        'tag-selector': TagSelector,
        'svg-icon': SvgIcon,
    },
    props: {
        parent: Object,
        service: null,
        title: String,
        type: String,
        model: null,
        canManage: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            addingTag: false,
            performingUpdateRequest: false,
        };
    },
    methods: {
        stopAddingTag() {
            this.$emit('close');
        },
        handleUpdate(tags) {
            if (!this.changed) {
                return;
            }

            this.performingUpdateRequest = true;
            this.service.update(this.parent.id, this.buildUpdateData(tags), ['tags']).then(result => {
                useRepo(Taggable)
                    .where('taggable_type', this.type)
                    .where('taggable_id', this.parent.id)
                    .delete();

                return this.model.save(normalizeJson(result));
            }).then(() => {
                this.performingUpdateRequest = this.addingTag = false;

                return this.stopAddingTag();
            });
        },
        changed(tags) {
            return _xorBy([...tags], this.parent.tags, 'id').length;
        },
        buildUpdateData(tags) {
            return {
                data: {
                    relationships: {
                        tags: {
                            data: tags
                        },
                    },
                },
            };
        }
    },
};

</script>
